import { Component } from "react";
import AliceCarousel from "react-alice-carousel";
import { isMobile } from "react-device-detect";

interface JobsCarouselProps {
  title: string;
  card: string[];
}
interface JobsCarouselState {
  galleryItems: JSX.Element[];
  items: {
    length: number;
  };
  currentIndex: number;
  responsive: {
    1024: {
        items: number;
    };
}
}

class JobsCarousel extends Component<JobsCarouselProps, JobsCarouselState> {
  componentWillReceiveProps() {
    this.setState({
      items: this.props.card,
      galleryItems: this.galleryItems(),
    });
  }

  constructor(props) {
    super(props);
    this.state = {
      items: [],
      currentIndex: 0,
      responsive: { 1024: { items: 4 } },
      galleryItems: this.galleryItems(),
    };
  }

  onSlideChanged = (event) => this.setState({ currentIndex: event.item });

  galleryItems() {
    return this.props?.card?.map((reactElement) => <div key={reactElement}> {reactElement}</div>);
  }

  render() {
    const { galleryItems, responsive, currentIndex } = this.state;
    return (
      <div className="mainCarouselsection">
        <div className="container">
          <h2 className="h2Carousel">{this.props.title}</h2>
          <AliceCarousel
            dotsDisabled={!!(!isMobile && this.props.card.length < 5)}
            buttonsDisabled
            items={galleryItems}
            autoPlayInterval={4000}
            autoPlayDirection="ltr"
            autoPlay={!(!isMobile && this.props.card.length < 5)}
            responsive={responsive}
            slideToIndex={currentIndex}
            onSlideChanged={this.onSlideChanged}
          />
        </div>
      </div>
    );
  }
}

export default JobsCarousel;
